<script>
  import options from './FrivilligeShopWrongRoleModal.options'
  export default options
</script>

<template>
  <article class="kb-frivillige-shop-wrong-role-modal">
    <section class="kb-frivillige-shop-wrong-role-modal__hero">
      <div class="kb-frivillige-shop-wrong-role-modal__hero__title-wrapper">
        <h2 class="kb-frivillige-shop-wrong-role-modal__hero__title-wrapper__title">
          {{ getLabel('title') }}
        </h2>
      </div>

      <div class="kb-frivillige-shop-wrong-role-modal__breaker">
        <svg viewBox="0 0 81 11" fill="none" xmlns="http://www.w3.org/2000/svg" ><path d="M2 .5h79v1H2v-1ZM1.5 2v9h-1V2h1Zm.5-.5a.5.5 0 0 0-.5.5h-1A1.5 1.5 0 0 1 2 .5v1Z" /></svg>
      </div>
      
      <div class="kb-frivillige-shop-wrong-role-modal__description">
        <p class="kb-frivillige-shop-wrong-role-modal__description-text">{{ getLabel('text') }}</p>
      </div>
    </section>

    <div class="kb-frivillige-shop-wrong-role-modal__hero__curve">
      <svg viewBox="0 0 720 77" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0V42.4078C238.547 71.2459 479.584 82.0555 720 74.8278V0H0Z" />
      </svg>
    </div>

    <div class="kb-frivillige-shop-wrong-role-modal__body">
        <p>{{ getLabel('buttonDescriptionText') }}</p>
        <button 
          class="kb-button kb-button--full-color-spot" 
          @keydown.tab="tabTrap" 
          data-order="first"
          v-on:click="redirect">
              {{ getLabel('buttonLabel') }} 
          <span class="kb-button__icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 24"><path fill="#fff" fill-rule="evenodd" d="m20.214 3.835-6.055-.3-.05-.999 6.555.325c.275.013.51.248.524.524l.324 6.554-.998-.05-.3-6.054ZM6.758 16.583l10.1-10.1.707.707-10.1 10.1-.707-.707ZM2.75 4.75h-.5v17.5h17.5v-9.781h-1v8.781H3.25V5.75h8.781v-1H2.75Z" clip-rule="evenodd"/></svg>
          </span>
        </button>
    </div>
  </article>
</template>
